import React from 'react';
import cx from 'classnames';

import classes from './Table.module.scss';

interface IProps {
  className?: string;
  onClick?: () => void;
  children: React.ReactNode;
}

const Row: React.FC<IProps> = ({ className, onClick, children }) => (
  <tr className={cx(classes.row, className)} {...{ onClick }}>{children}</tr>
);

export default Row;
